import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { Empresa, useUsuario } from "../Hooks/UsuarioHook";
import { useUsuarioPrefeitura } from "../Hooks/UsuarioPrefeituraHook";
import { API } from "../Services/Api";
import {
  api_url,
  aplicacao,
  app_base_url,
  enderecos_api,
  itbi_sql_server_url,
  login_api,
} from "../Utils/Urls";
import { useUsuarioNaoEmiteNota } from "../Hooks/UsuarioNaoEmiteNotaHook";

interface IEmpresaContextData {
  empresa: Empresa[];
  getEmpresaFocus(codigo: number): Promise<Empresa>;
}

interface IEmpresaProviderProps {
  children: ReactNode;
}

const EmpresaContext = createContext({} as IEmpresaContextData);
export const token_storage = "@login-unico";

function EmpresaProvider({ children }: IEmpresaProviderProps) {
  const { usuarioPrefeitura } = useUsuarioPrefeitura();
  const { usuarioCompleto } = useUsuario();
  const { usuarioNaoEmiteNota } = useUsuarioNaoEmiteNota();
  const [empresa, setEmpresa] = useState([] as Empresa[]);
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  async function getData() {

    try {
      setLoading(true);
      const { data } = await API.get(`/empresa/prefeitura/todas`);
      //  window.alert(JSON.stringify(data));
      if (data.status) setEmpresa(data.data);
    } catch (e) {
      console.log(e);

    } finally {
      setLoading(false);
    }
  }

  async function getEmpresaFocus(codigo: number) {
    try {
      setLoading(true);

      const pertence_ao_usuario = Array.isArray(usuarioCompleto.empresas) &&
        usuarioCompleto.empresas.some(empresa => empresa.CODIGO_FIRMA === codigo);

      if (pertence_ao_usuario || usuarioPrefeitura.usuario) {
        const { data } = await API.get(`/empresa/${usuarioPrefeitura.usuario ? `prefeitura` : `usuario`}/${codigo}`);
        //window.alert(JSON.stringify(data));
        if (data.status) return data.data[0];
      }

      if(usuarioNaoEmiteNota.CODIGO == codigo){
        const { data } = await API.get(`/empresa/usuario/${codigo}`);
        //window.alert(JSON.stringify(data));
        if (data.status) return data.data[0];
      }

    } catch (e) {
      console.log(e);

      window.alert(
        "NAO FOI POSSÍVEL CARREGAR OS DADOS REFERENTES A ESTE REGISTRO!"
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (usuarioPrefeitura.usuario) {
      getData();
    }
  }, [usuarioPrefeitura]);

  return (
    <EmpresaContext.Provider value={{ empresa, getEmpresaFocus }}>
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </EmpresaContext.Provider>
  );
}

function useEmpresa() {
  const context = useContext(EmpresaContext);

  return context;
}

export { EmpresaProvider, useEmpresa };
